module.exports = __webpack_public_path__ + "img/rule-1.87a130cc.png";